<template>
	<section class="quit_form">
		<Nav title="申请退单" />
		<section class="form">
			<section class="order_info">
				<h3>订单信息<img src="../../assets/img/quit_tit_line.png" /></h3>
				<p class="item">
					<span class="t_sapn">客户姓名</span>
					<span>{{orderInfoObj.name}}</span>
				</p>
				<p class="item">
					<span class="t_sapn">接单时间</span>
					<span>{{orderInfoObj.createTime}}</span>
				</p>
				<p class="item">
					<span class="t_sapn">支付金额</span>
					<span>{{orderInfoObj.amount}}币</span>
				</p>
			</section>
			<section class="create_quit">
				<h3>申请信息</h3>
				<div class="reason">
					<p class="tit_p">退单原因<i>*</i></p>
					<p class="box">
						<span v-for="item in reasonList" :key="item.id" :class="{active: item.id==activeId}" @click="chooseReason(item)">{{item.name}}</span>
					</p>
				</div>
				<div class="upload">
					<p class="tit_p">附件照片</p>
					<div class="boxs">
						<div class="item">
							<div class="no_cover" v-if="!cover1" @click="chooseImg(1)">
								<img src="../../assets/img/quit_upload.png" class="upload_bg">
							</div>
							<div class="cover" v-else>
								<img src="../../assets/img/quit_del.png" class="del" @click="delCoverFn(1)">
								<img :src="cover1" class="upload_c">
							</div>
						</div>
						<div class="item">
							<div class="no_cover" v-if="!cover2"  @click="chooseImg(2)">
								<img src="../../assets/img/quit_upload.png" class="upload_bg">
							</div>
							<div class="cover" v-else>
								<img src="../../assets/img/quit_del.png" class="del" @click="delCoverFn(2)">
								<img :src="cover2" class="upload_c">
							</div>
						</div>
						<div class="item">
							<div class="no_cover" v-if="!cover3"  @click="chooseImg(3)">
								<img src="../../assets/img/quit_upload.png" class="upload_bg">
							</div>
							<div class="cover" v-else>
								<img src="../../assets/img/quit_del.png" class="del" @click="delCoverFn(3)">
								<img :src="cover3" class="upload_c">
							</div>
						</div>

					</div>
				</div>
				<div class="desc">
					<p class="tit_p">补充描述</p>
					<van-field v-model="form.refundDescription" rows="6" type="textarea" maxlength="120" placeholder="请输入描述,最多120字" show-word-limit />
				</div>
			</section>
			<section class="descc">
				<h4>退单规则</h4>
				<p>1. 空号、停机：可申请退单；</p>
				<p>2. 关机、无人接听：可申请退单，需提供2天内6次联系证明；</p>
				<p>3. 客户无意向、不需要：可申请退退单，需提供通话录音或者聊天截图证明；</p>
				<p>4. 嫌麻烦、费用高、不面签：不可申请退单；</p>
				<p>5. 已经解决资金问题：不可申请退单；</p>
				<p>6. 资质不好、大数据不好、黑户：不可申请退单；</p>
				<p>7. 通话录音请添加客服微信发送；</p>
				<p>8. 接单后超过3天（72小时）不可申请退单。</p>
			</section>
		</section>
		<div class="submit_class">
			<van-button type="primary" :class="{active: activeId.toString()}" @click="primary">提交申请</van-button>
		</div>
	</section>
</template>

<script>
import Nav from "components/Nav"
import { Notify,Dialog } from 'vant';
import clienteleServer from "api/clientele";


export default {
	components: {
		Nav,
	},
	data() {
		return {
			orderInfoObj: {
				name: '',
				createTime: '',
				amount: '',
			},
			form: {
				orderId: '',
				refundReason: '',
				refundPhotos: '',
				refundDescription: '',
			},
			cover1: '',
			cover2: '',
			cover3: '',
			reasonList: [],
			activeId: '',
		}
	},
	created() {
		this.form.orderId = this.$route.params.id
		this.orderInfo()
		this.getReason()
	},
		mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		getReason() {
			clienteleServer.SearchReason().then((res) => {
				for(let key in res.data) {
					this.reasonList.push({
						id: key,
						name: res.data[key],
					})
				}
			})
		},
		
		orderInfo() {
			clienteleServer.SearchClienteleInfo({orderId: this.form.orderId}).then((res) => {
				this.orderInfoObj.name = res.data.require.basicInfo.name
				this.orderInfoObj.createTime = res.data.createTime
				this.orderInfoObj.amount = res.data.require.amount
			})
		},
		chooseReason(row) {
			this.activeId = row.id
			this.form.refundReason = row.id
		},


		//上传图片
		chooseImg(type) {
			kk_requestPhotoLibraryAuthorization((res)=>{
				if(res.code == 1) {
					this.chooseLocalityImg(type)
				}else if(res.code == 2) {
					Notify({ type: 'danger', message: '	请选择图片' })
				}else {
					Notify({ type: 'danger', message: '请打开图片权限' })
				}
			});
		},
		chooseLocalityImg(type) {
			kk_chooseImage((res)=>{
				if (res.code == 1){
					var imageBase64 = res.data;
					let file = this.base64ToFile(imageBase64, (new Date()).valueOf())
					this.uploadOss(file, type)
				}else {
					Notify({ type: 'danger', message: '获取图片失败，请重试' })
				}
			});
		},
		base64ToFile(urlData, fileName) {
			let arr = urlData.split(',');
			let mime = arr[0].match(/:(.*?);/)[1];
			let bytes = atob(arr[1]); // 解码base64
			let n = bytes.length
			let ia = new Uint8Array(n);
			while (n--) {
				ia[n] = bytes.charCodeAt(n);
			}
			return new File([ia], fileName, { type: mime });
		},
		
		uploadOss(file, num) {
			if(file.size/1024>5120){
				Notify({ type: 'danger', message: '图片不能大于5M' })
				return
			}   
			let	params = new FormData()
			params.append('file', file)
			clienteleServer.Upload(params).then((res) => {
				this[`cover${num}`] = res.data
			})
		},
		delCoverFn(num) {
			this[`cover${num}`] = ''
		},
		primary() {
			// if(!this.activeId.toString()) return Notify({ type: 'danger', message: '请选择退单原因' })
			let arr = []
			if(this.cover1) {
				arr.push(this.cover1+';')
			}
			if(this.cover2) {
				arr.push(this.cover2+';')
			}

			if(this.cover3) {
				arr.push(this.cover3+';')
			}
			for(let i=0; i<arr.length; i++) {
				if(!arr[i]) {
				 	arr.splice(i, 1)
					i= i-1
				}
			}

			this.form.refundPhotos = arr = arr.toString().replace(/;,/g, ';')
			clienteleServer.quitCreate(this.form).then((res) => {
				Dialog.alert({ title: '提交成功', message:'2个工作日内反馈退单申请审核结果'}).then(() => {
					this.$router.push({name:'clientele'})
				})
			})
			
		}

	}
}
</script>

<style lang="scss">
	.quit_form {
		padding-top: 46px;
		padding-bottom: 60px;
		.descc {
			font-size: 16px;
			color: #7D8290;
			h4 {
				font-weight: bold;
				padding: 23px 0;
				padding-bottom: 20px;
				font-size: 16px;
			}
			p {
				padding-bottom: 14px;
				font-size: 15px;
			}
		}
		.form {
			padding: 15px;
			h3 {
					position: relative;
					height: 54px;
					line-height: 54px;
					padding-left: 13px;
					color: #2B2F3A;
					font-size: 16px;
					font-weight: bold;
					margin-bottom: 4px;
					img {
						position: absolute;
						bottom: 0;
						left: 0;
						width: 100%;
						height: 2Px;
					}
				}
			.order_info {
				background: #fff;
				border-radius: 4px;
				.item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 10px 13px;
					span {
						color: #2B2F3A;
						font-size: 15px;
					}
					.t_sapn {
						color: #7D8290;
					}

				}
			}
			.create_quit {
				margin-top: 15px;
				background: #fff;
				border-radius: 4px;
				h3 {
					border: 1px solid #F6F6F6;
				}
				.reason {
					display: flex;
					justify-content: space-between;
					// align-items: center;
					padding: 0 13px;
					.tit_p {
						position: relative;
						color: #7D8290;
						font-size: 15px;
						min-width: 62px;
						padding-top: 22px;
						i {
							position: absolute;
							font-style: normal;
							color: #FC0E2D;
							transform: translateX(100%);
							top: 22px;
							right: 0;
						}
					}
					.box {
						padding-top: 20px;
						display: flex;
						flex-wrap: wrap;
						border-bottom: 1px solid #F6F6F6;
						padding-left: 18px;
						span {
							display: block;
							padding: 4px 7px;
							background: #EFF0F4;
							color: #7D8290;
							margin-right: 12px;
							font-size: 14px;
							border-radius: 1px;
							margin-bottom: 20px;
							&:nth-of-type(4n) {
								margin-right: 0;
							}
							&:last-of-type {
								margin-right: 0;
							}
						}
						.active {
							color: #3A5EEC;
							background: #E1F7FE;
						}
					}
				}
			}
			.upload {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0 13px;
				.tit_p {
					color: #7D8290;
					font-size: 15px;
					min-width: 62px;
				}
				.boxs {
					display: flex;
					justify-content: space-between;
					padding: 20px 0;

					.item {
						width: 70px;
						height: 70px;
						margin-right: 12px;
						&:last-of-type {
							margin-right: 0;
						}
						.no_cover {
							position: relative;
							border-radius: 2px;
							background: #EFF0F4;
							height: 100%;
							img {
								position: absolute;
								width: 23px;
								top: 50%;
								left: 50%;
								transform: translate(-50%, -50%);
							}
							input {
								position: absolute;
								top: 0;
								left: 0;
								z-index: 2;
								width: 100%;
								height: 100%;
								opacity: 0;
							}
						}
						.cover {
							position: relative;
							border-radius: 2px;
							background: #EFF0F4;
							height: 100%;
							.del {
								position: absolute;
								top: 0;
								right: 0;
								width: 30px;
							}
							.upload_c {
								object-fit: contain;
								width: 100%;
								height: 100%;								
							}
						}
					}
				}
			}
			.desc {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0 13px;
				.tit_p {
					color: #7D8290;
					font-size: 15px;
					min-width: 62px;
					margin-right: 23px;
				}
				textarea::-webkit-input-placeholder {
					color: #7D8290 !important;
				}
				.van-cell {
					padding:5px 6px;
					margin-bottom: 20px;
					border: 1Px solid #F6F6F6;
					border-radius: 2px;
					background: transparent;
					.van-field__control {
						font-size: 14px;
						color: #2B2F3A;
					}
				}
			}
			
		}
		.van-button--primary {
			width: 100%;
			height: 46px;
			background: #D2D8E9;
			border-radius: 1px;
			border: 0;
			font-size: 16px;
			color: #ffffff;
		}
		.submit_class {
			position: fixed;
			bottom: 0px;
			left: 0;
			width: 100%;
			padding-top: 3px;
			box-sizing: border-box;
			.active {
				background: #3A5EEC;
			}
			
		}
		
		
	}
</style>


// WEBPACK FOOTER //
// src/views/quitForm/Index.vue